import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import moment from 'moment';
import { Typography, Box, FormControl, Grid } from '@material-ui/core';
import { KailonaButton, KailonaTable, KailonaDateRangePicker } from '@kailona/ui';
import { Edit, Delete } from '@material-ui/icons';
import ActivitiesService from '../services/ActivitiesService';
import { Logger, fhirDataFormatter } from '@kailona/core';
import ActivitiesEditModal from './ActivitiesEditModal';
var logger = new Logger('Activities.ActivitiesDataModule');

var ActivitiesDataModule = /*#__PURE__*/function (_Component) {
  _inherits(ActivitiesDataModule, _Component);

  var _super = _createSuper(ActivitiesDataModule);

  function ActivitiesDataModule(props) {
    var _this;

    _classCallCheck(this, ActivitiesDataModule);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatActivityTime", function (activities) {
      return activities.map(function (activity) {
        return _objectSpread({
          datePeriodFormatted: fhirDataFormatter.formatDatePeriod(activity.datePeriod)
        }, activity);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchActivities", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var filters, params, activities, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                loading: true
              });

              filters = _this.state.filters;
              _context.prev = 2;
              params = [{
                date: "ge".concat(moment(filters.dateRange.begin).hour(0).minute(0).second(0).utc().toISOString())
              }, {
                date: "le".concat(moment(filters.dateRange.end).hour(23).minute(59).second(59).utc().toISOString())
              }, {
                _sort: '-date',
                _count: _this.state.rowsPerPage
              }];
              _context.next = 6;
              return _this.activitiesService.fetchData(params);

            case 6:
              activities = _context.sent;
              data = _this.formatActivityTime(activities);

              _this.setState({
                loading: false,
                data: data
              });

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              logger.error(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchNextActivities", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var nextActivities, allActivities;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.activitiesService.hasNextData) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _this.setState({
                loading: true
              });

              _context2.prev = 3;
              _context2.next = 6;
              return _this.activitiesService.fetchNextData(_this.state.data);

            case 6:
              nextActivities = _context2.sent;
              allActivities = [].concat(_toConsumableArray(_this.state.data), _toConsumableArray(nextActivities));

              _this.setState({
                loading: false,
                data: _this.formatActivityTime(allActivities)
              });

              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              logger.error(_context2.t0);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 11]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.fetchActivities();
    });

    _defineProperty(_assertThisInitialized(_this), "filterByDateRange", function (dateRangeValue) {
      var filters = _this.state.filters;
      filters.dateRange = dateRangeValue;

      _this.setState({
        filters: filters
      }, function () {
        _this.fetchActivities();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSave", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(activitiesData) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.setState({
                  savingActivities: true
                });

                _context3.prev = 1;
                _context3.next = 4;
                return _this.activitiesService.upsertData(activitiesData);

              case 4:
                _this.activitiesEditModalRef.current.toggleModal(false);

                _this.fetchActivities();

                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                logger.error(_context3.t0);

              case 11:
                _this.setState({
                  savingActivities: false
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleDelete", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(activitiesData) {
        var observationId;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                observationId = activitiesData.id;

                _this.setState({
                  savingActivities: true
                });

                _context4.prev = 2;
                _context4.next = 5;
                return _this.activitiesService.removeData(observationId);

              case 5:
                _this.activitiesEditModalRef.current.toggleModal(false);

                _this.fetchActivities();

                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](2);
                logger.error(_context4.t0);

              case 12:
                _this.setState({
                  savingActivities: false
                });

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 9]]);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onChangePage", function (e, page) {
      _this.setState({
        page: page
      }, function () {
        _this.fetchActivities();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeRowsPerPage", function (e) {
      var value = e.target.value;

      _this.setState({
        rowsPerPage: value
      }, function () {
        _this.fetchActivities();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddNewActivities", function () {
      _this.setState({
        activitiesDataToUpdate: null
      }, function () {
        _this.activitiesEditModalRef.current.toggleModal(true);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEditActivities", function (activitiesData) {
      _this.setState({
        activitiesDataToUpdate: activitiesData
      }, function () {
        _this.activitiesEditModalRef.current.toggleModal(true);
      });
    });

    _this.state = {
      loading: true,
      filters: {
        dateRange: {
          begin: moment().clone().subtract(1, 'month'),
          end: moment()
        }
      },
      page: 0,
      rowsPerPage: 25,
      data: [],
      columns: [{
        label: '',
        key: 'datePeriodFormatted'
      }, {
        label: t('ehr', 'Steps'),
        key: 'steps'
      }, {
        label: t('ehr', 'Distance'),
        key: 'distance'
      }, {
        label: t('ehr', 'Calories'),
        key: 'calories'
      }],
      activitiesDataToUpdate: null,
      savingActivities: false
    };
    _this.contextMenuOptions = [{
      label: t('ehr', 'Edit'),
      icon: /*#__PURE__*/React.createElement(Edit, {
        fontSize: "small"
      }),
      onClick: _this.onEditActivities
    }, {
      label: t('ehr', 'Delete'),
      icon: /*#__PURE__*/React.createElement(Delete, {
        fontSize: "small"
      }),
      onClick: _this.handleDelete
    }];
    _this.activitiesService = new ActivitiesService();
    _this.activitiesEditModalRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(ActivitiesDataModule, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          filters = _this$state.filters;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3"
      }, t('ehr', 'Activities'))), /*#__PURE__*/React.createElement(Box, {
        className: "add-new",
        mt: 2
      }, /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Add New Activity'),
        onClick: this.onAddNewActivities
      })), /*#__PURE__*/React.createElement(Box, {
        className: "filters",
        mt: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center",
        justifyContent: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        style: {
          marginRight: '6px'
        }
      }, t('ehr', 'Filter by'), ":", ' ')), /*#__PURE__*/React.createElement(Grid, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaDateRangePicker, {
        id: "date",
        defaultValue: filters.dateRange,
        onChange: this.filterByDateRange,
        ariaLabel: t('ehr', 'Filter by date'),
        maxDate: new Date()
      })))))), /*#__PURE__*/React.createElement(Box, {
        className: "content",
        mt: 3,
        style: {
          display: 'flex',
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(KailonaTable, {
        data: this.state.data,
        columns: this.state.columns,
        page: this.state.page,
        rowsPerPage: this.state.rowsPerPage,
        onChangePage: this.onChangePage,
        onChangeRowsPerPage: this.onChangeRowsPerPage,
        contextMenu: this.contextMenuOptions,
        onEdit: this.onEditActivities,
        loading: loading,
        fetchNewData: this.fetchNextActivities
      })), /*#__PURE__*/React.createElement(ActivitiesEditModal, {
        ref: this.activitiesEditModalRef,
        activitiesData: this.state.activitiesDataToUpdate,
        handleSave: this.handleSave,
        savingActivities: this.state.savingActivities
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ActivitiesDataModule;
}(Component);

export { ActivitiesDataModule as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/components/ActivitiesDataModule.js");
  reactHotLoader.register(ActivitiesDataModule, "ActivitiesDataModule", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/components/ActivitiesDataModule.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();